<template>
  <v-row justify="center">
    <v-dialog :value="true" persistent max-width="290">
      <v-card :color="backgroundColor">
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text>
          <div v-html="message"></div>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn
            v-for="btn in dialogBtns"
            :key="btn.title"
            :color="btn.color || btnColor"
            text
            @click="btn.click"
            >{{ btn.title }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  name: 'DialogMessageBox',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: String,
      default: ''
    },
    backgroundColor: {
      type: String,
      default: 'white'
    },
    btnColor: {
      type: String,
      default: 'primary'
    },
    dialogBtns: {
      type: Array,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped></style>
